(() => {
  const configElementId = 'AmpDeliveryCustomerAddress';
  const appAddressStorageKey = 'cart-delivery-datetime__address';
  const prefillMarkerStorageKey = 'hazet-amp-delivery-default-address';
  const appContainerId = 'cart-delivery-datetime_embedded';
  const appWrapperClass = 'cart-delivery-datetime_checkout-wrapper';
  const noticeClass = 'amp-delivery-address-caution';
  const noticeText = 'チェックアウトで配送先を変更した場合は、指定可能日が変わる場合があります。';

  function readCustomerAddress() {
    const configElement = document.getElementById(configElementId);

    if (!configElement) return null;

    try {
      return JSON.parse(configElement.textContent);
    } catch (error) {
      console.warn('配送先住所の初期設定を読み込めませんでした。', error);
      return null;
    }
  }

  function normalizePostalCode(value) {
    return String(value || '').replace(/\D/g, '').slice(0, 7);
  }

  function normalizePrefectureCode(value) {
    const normalizedValue = String(value || '').trim();
    const codeMatch = normalizedValue.match(/(\d{1,2})$/);

    return codeMatch ? `JP-${codeMatch[1].padStart(2, '0')}` : '';
  }

  function syncDefaultAddress() {
    const config = readCustomerAddress();

    if (!config) return;

    let previousMarker = null;

    try {
      previousMarker = localStorage.getItem(prefillMarkerStorageKey);

      if (!config.loggedIn) {
        if (previousMarker) {
          localStorage.removeItem(appAddressStorageKey);
          localStorage.removeItem(prefillMarkerStorageKey);
        }
        return;
      }

      const postalCode = normalizePostalCode(config.postalCode);
      const prefecture = String(config.prefecture || '').trim();
      const prefectureCode = normalizePrefectureCode(config.prefectureCode);

      if (postalCode.length !== 7 || !prefecture) {
        if (previousMarker) {
          localStorage.removeItem(appAddressStorageKey);
          localStorage.removeItem(prefillMarkerStorageKey);
        }
        return;
      }

      const appAddress = {
        postalCode,
        '都道府県': prefecture,
        prefcode: prefectureCode
      };
      const currentMarker = JSON.stringify({
        customerId: String(config.customerId || ''),
        ...appAddress
      });

      if (!localStorage.getItem(appAddressStorageKey) || previousMarker !== currentMarker) {
        localStorage.setItem(appAddressStorageKey, JSON.stringify(appAddress));
      }

      localStorage.setItem(prefillMarkerStorageKey, currentMarker);
    } catch (error) {
      console.warn('配送先住所を初期設定できませんでした。', error);
    }
  }

  function placeAddressCaution() {
    const appContainer = document.getElementById(appContainerId);
    const appWrapper = appContainer?.closest(`.${appWrapperClass}`);

    if (!appContainer || !appWrapper) return;

    const currentNotice = appWrapper.querySelector(`.${noticeClass}`);

    if (currentNotice && currentNotice.previousElementSibling === appContainer) return;

    document.querySelectorAll(`.${noticeClass}`).forEach((notice) => notice.remove());

    const notice = document.createElement('p');
    notice.className = noticeClass;
    notice.setAttribute('role', 'note');
    notice.textContent = noticeText;
    appContainer.insertAdjacentElement('afterend', notice);
  }

  syncDefaultAddress();
  placeAddressCaution();

  if (!window.hazetAmpDeliveryAddressObserver) {
    window.hazetAmpDeliveryAddressObserver = new MutationObserver(placeAddressCaution);
    window.hazetAmpDeliveryAddressObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();
